import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Button } from "@material-ui/core";
import PaperContainer from "../../Common/PaperContainer";
import AboveTableBtnArea from "../../Common/AboveTableBtnArea";
import t from "../../../languages/pl";
import OperatorsTable from './OperatorsTable';
import OperatorsDialog from "./OperatorsDialog";
import ActionCreator from './../../../store/actions/index';

const Operators = props => {
    const { operators, addRentOperator, putRentOperator, deleteRentOperator, operatorPasswordExpirationChange,
        rentOperatorPasswordReset } = props;
    const [open, setOpen] = useState(false);
    const [operatorId, setOperatorId] = useState(null);
    const [operator, setOperator] = useState(null);

    const handleOperatorDetailsDialog = id => {
        setOpen(true);
        setOperatorId(id);
        setOperator(operators.find(operator => operator.operator_id === id));

    };

    const handleDialogClose = (initialState) => {
        setOpen(false);
        setOperator(initialState);
        setOperatorId(null);
    };

    const handleOperatorDelete = (id, initialState) => {
        setOpen(false);
        setOperator(initialState);
        setOperatorId(null);
        deleteRentOperator(id);
    };

    const handleOperatorAdd = (newOperator, initialState) => {
        setOpen(false);
        setOperator(initialState);
        addRentOperator(newOperator);
    };

    const handleOperatorEdit = (updatedOperator, initialState) => {
        setOpen(false);
        setOperator(initialState);
        putRentOperator(updatedOperator.operator_id, updatedOperator);
    };

    const handlePasswordExpiration = (id, value) => {
        operatorPasswordExpirationChange(id,value);
    };

    const handlePasswordReset = (id) => {
        rentOperatorPasswordReset(id);
    };

    return (
        <PaperContainer>
            <AboveTableBtnArea>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(true)}
                >
                    {t.add}
                </Button>
            </AboveTableBtnArea>
            <OperatorsTable
                operators={operators}
                onOperatorDetailsShow={handleOperatorDetailsDialog}
            />
            <OperatorsDialog
                open={open}
                onClose={handleDialogClose}
                isEdit={operatorId !== null}
                inputData={operator}
                onSubmit={handleOperatorAdd}
                onEdit={handleOperatorEdit}
                onOperatorDelete={handleOperatorDelete}
                onPasswordReset={handlePasswordReset}
                onPasswordExpirationChange={handlePasswordExpiration}
            />
        </PaperContainer>
    );
};

Operators.propTypes = {
    operators: PropTypes.array,
    addRentOperator: PropTypes.func,
    putRentOperator: PropTypes.func,
    deleteRentOperator: PropTypes.func,
    operatorPasswordExpirationChange: PropTypes.func,
    rentOperatorPasswordReset: PropTypes.func,
};

const mapStateToProps = state => ({
    operators: state.rentReducer.operators,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Operators);